import Vue from "vue";
import Router from "vue-router";
import Home from "../src/components/Home/Home.vue";
import FullPage from "../src/views/FullPage.vue"
import Callback from "../src/components/Callback/Callback.vue"
import PageLoader from "../src/views/PageLoader/PageLoader.vue"
import Construction from "../src/views/Construction.vue"
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/callback",
      name: "callback",
      component: Callback
    },
  {
    path: "/",
    name: "fullpage",
    component: Construction
  },
  {
    path: "*",
    name: "Construction",
    component: Construction
  }]
});